import { Tooltip } from "antd";
import { FC, useState } from "react";
import _t from "../lang/translate";

interface CopyableContentProps extends React.HTMLAttributes<HTMLDivElement> {
  contentToCopy: string;
  displayContent?: boolean
}

const CopyableContent: FC<CopyableContentProps> = ({ contentToCopy, displayContent, children, ...rest }) => {
  const getText = () => displayContent ? `${_t("click_to_copy")}: ${contentToCopy}` : _t("click_to_copy")
  const [tooltipText, setTooltipText] = useState<string>(() => getText());

  const handleCopy = () => {
    navigator.clipboard.writeText(`${contentToCopy || 0}`);
    setTooltipText(_t("copied"));
  };

  const handleVisibleChange = (isVisible: boolean) => !isVisible && setTooltipText(getText());

  return (
    <Tooltip title={tooltipText} afterVisibleChange={handleVisibleChange} {...rest}>
      <span onClick={handleCopy}>{children}</span>
    </Tooltip>
  );
};

export default CopyableContent;
